// extracted by mini-css-extract-plugin
export var container = "_7h-0";
export var error = "_7h-9";
export var label = "_7h-5";
export var light = "_7h-6";
export var md = "_7h-3";
export var sm = "_7h-2";
export var thin = "_7h-8";
export var thinBold = "_7h-7";
export var vertical = "_7h-4";
export var xs = "_7h-1";